import React, { useState, useEffect } from "react";
import useFetch from "hooks/useFetch";
import config from "config.json";
import { useNavigate } from "react-router-dom";

interface User {
    firstname: string;
    lastname: string;
    document: string;
    mail: string;
    id: number;
    phones: Phone[];
    semaphore_status: number;
    observations: string;
}

interface Phone {
    phone_number: string;
    active: boolean;
}

const DocumentationAlert = () => {

    const router = useNavigate();

    const [semaphore, setSemaphore] = useState(0);

    const sesion = sessionStorage.getItem('user_token');

    const { data, error, isLoading, fetchData } = useFetch<User>(
        'GET', `${config.backend_url}/authe/token`,
        {},
        { 'Content-Type': 'application/json', 'SetiaAuthorization': `${sessionStorage.getItem('user_token')}` }
    );

    useEffect(() => {
        if (sesion !== null) {
            fetchData();
        }else{
            setSemaphore(2);
        }
    }, []);

    useEffect(() => {
        if (data?.semaphore_status != null) {
            setSemaphore(data.semaphore_status);
        }
    }, [data]);

    const handleGoDocumentation = () => {

        router('/account-documents');
      
    };

    if (semaphore === 2 ) {
        sessionStorage.setItem('semaphore', semaphore.toString());
    }

    if (sesion === null) {
        return null;
    }

    if (semaphore !== 2) {
        sessionStorage.setItem('semaphore', semaphore.toString());
    }

    if (semaphore !== 2){


        return (
            <div className="container mt-8">
                <div
                    id="alert-2"
                    className="flex flex-col md:flex-row items-start md:items-center p-4 mb-6 text-red-800 rounded-lg bg-red-200 dark:bg-gray-800 dark:text-red-400"
                    role="alert"
                >
                    <svg
                        className="flex-shrink-0 w-8 h-8 mr-2 mb-4 md:mb-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                    </svg>
                    <div className="ms-0 md:ms-4 text-lg md:text-base font-medium">
                        Necesitamos que realices acciones en la documentación de tu cuenta para poder realizar reservas.{' '}
                        <a onClick={handleGoDocumentation} className="font-semibold underline cursor-pointer">Ir a documentación</a>
                    </div>
                </div>
            </div>
        );
    }else{
        return null
    }
};

export default DocumentationAlert;